import { R_EXPERTISE } from '../routes';

const ClientExpertise = () => import(/* webpackChunkName: "Expertise" */ '@/views/ClientExpertise');

export default {
  name: R_EXPERTISE,
  meta: {
    title: 'Expertise',
  },
  path: '/expertise',
  component: ClientExpertise,
};
